/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import BottomFooter from '../BottomFooter'
import Loader from '../Loader'
import { useNavigate } from 'react-router-dom'
import Slider from 'react-slick';
import { useSelector } from 'react-redux';
import { styleObjectGetBG, styleObjectGetBorderColor } from '../../common/StyleSeter';

const whoitsforsettings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  // variableWidth: true,
  arrows: false,
};


function MyProfile(_props: any) {
  const [isLoadingMain, setIsLoadingMain] = useState(false)
  const [during, setDuring] = useState(false)
  const navigate = useNavigate()
  const header = useSelector((e: any) => e.Header)
  const DD = useSelector((e: any) => e.domainDetails);

  // useEffect(() => {
  //   if (header) {
  //     console.log("Header data: ", header)
  //   }
  // }, [])


  return (
    <>
      <div className='full-wrap bottomfooter leagues'>
        {isLoadingMain ?
          <div className='loader_top'>
            <Loader />
          </div>
          :
          <>
            <style>{`
                    .paddingZero {
                    padding-left: 0px !important;
                    }
                `}</style>
            <div className="paddingZero balance-label position-relative" style={{ fontSize: "14.56px", fontWeight: 400 }}>
              {/* <button className="bg-transparent border-0 text-white position-absolute start-0 pt-0" onClick={() => navigate('/')}>
                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 256 512" className="fs-3" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                  <path d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"></path>
                </svg>
              </button> */}
              My Profile
              <div className='cross-icon' onClick={() => navigate('/')} />
            </div>

            <div className="p-3 inner-sidebar-content">
              <table className="align-middle bg-white table">
                <tbody>
                  <tr>
                    <td width="40%" style={{ fontSize: "12.48px", fontWeight: 400 }}>First Name</td>
                    <td width="60%" colSpan={2} style={{ fontSize: "12.48px", fontWeight: 700, color: "#6F8898" }}>{header?.firstName || "--"}</td>
                  </tr>
                  <tr>
                    <td width="40%" style={{ fontSize: "12.48px", fontWeight: 400 }}>Last Name</td>
                    <td width="60%" colSpan={2} style={{ fontSize: "12.48px", fontWeight: 700, color: "#6F8898" }}>{header?.lastName || "--"}</td>
                  </tr>
                  <tr>
                    <td width="40%" style={{ fontSize: "12.48px", fontWeight: 400 }}>Email</td>
                    <td width="60%" colSpan={2} style={{ fontSize: "12.48px", fontWeight: 700, color: "#6F8898" }}>{header?.email || "--"}</td>
                  </tr>
                  <tr>
                    <td width="40%" style={{ fontSize: "12.48px", fontWeight: 400 }}>Contact Number</td>
                    <td width="60%" colSpan={2} style={{ fontSize: "12.48px", fontWeight: 700, color: "#6F8898" }}>{header?.mobileNumber || "--"}</td>
                  </tr>
                  <tr>
                    <td width="40%" style={{ fontSize: "12.48px", fontWeight: 400 }}>User Name</td>
                    <td width="60%" colSpan={2} style={{ fontSize: "12.48px", fontWeight: 700, color: "#6F8898" }}>{header?.user_name}</td>
                  </tr>
                  <tr>
                    <td width="40%" style={{ fontSize: "12.48px", fontWeight: 400 }}>Password</td>
                    <td width="35%" style={{ fontSize: "12.48px", fontWeight: 700, color: "#6F8898" }}>********</td>
                    <td width="25%" style={{ display: "flex", justifyContent: "end", width: "100%" }}>
                      <style>
                        {`.btn-edit {
                          border-radius: 2px !important;
                          font-size: 11.44px !important;
                          font-weight: 400 !important;
                          line-height: 1.2 !important;
                          color: #000 !important;
                          margin: 0;
                          transition: all 0.5s ease;

                          @media (max-width: 480px) {
                              font-size: 11.44px !important;
                              padding: 0 !important;
                          }
                      }`}
                      </style>
                      <button type="button" onClick={() => window.location.href = '/change/password'} className="btn-edit theme-btn btn btn-primary" style={{ ...styleObjectGetBG(DD?.colorSchema), ...styleObjectGetBorderColor(DD?.colorSchema) }}><span style={{ fontSize: "11.44px", fontWeight: 400, lineHeight: 1.2 }}>Edit</span></button></td>
                  </tr>
                </tbody>
              </table>
            </div>

          </>
        }
      </div>



      {during && <div className="market-depth-modal">
        <div className="market-title">
          <h4>During</h4>
          <button type="button" onClick={() => setDuring(false)} className="border-0 abc text-white position-absolute end-0 top-0 pt-1 fs-4 bg-transparent border-0 btn btn-primary">
            <svg stroke="currentColor" fill="none" strokeWidth="0" viewBox="0 0 15 15" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z" fill="currentColor"></path>
            </svg>
          </button>
        </div>
        <div className="d-flex justify-content-center align-items-center w-100">
          <div className="p-2 calendar-button"><button type="button" className="btn btn-primary">Today</button><button type="button" className="btn btn-primary">From Yesterday</button><button type="button" className="btn btn-primary">Last 7 Days</button></div>
        </div>
      </div>
      }
    </>



  )
}

export default MyProfile